import styled from "styled-components";
import {MaskFabricDefaultBox} from "./mask-fabric.default.box";
import {hexToRgba} from "../../../../../themes/hex-to-rgba";

export const MaskFabricCasino777Box = styled(MaskFabricDefaultBox)`
    background: linear-gradient(${({theme}) => hexToRgba(theme.colors.brandSecondary, 1)} 0%, ${({theme}) => hexToRgba(theme.colors.brandPrimary, 0.6)} 150%);
`;